import React from 'react'
import trading_routes from './modules/trading/_routes'
import account_routes from './modules/account/_routes'
import inventory_management_routes from './modules/inventory-management/_routes'
import human_resource_management_routes from './modules/human-resource-management/_routes'
import project_management_routes from './modules/project-management/_routes'
import job_management_routes from './modules/job-management/_routes'
import meeting_management_routes from './modules/meeting-management/_routes'
import questionnaire_management_routes from './modules/questionnaire-management/_routes'

import _modules from './_modules'

const Dashboard = React.lazy(() => import('./views/dashboard/Dashboard'))

const BusinessEntities = React.lazy(() => import('./views/businessEntities/BusinessEntities'))
const BusinessEntitiesDetail = React.lazy(() =>
  import('./views/businessEntities/BusinessEntitiesDetail'),
)
const BusinessEntityNotices = React.lazy(() =>
  import('./views/businessEntityNotices/BusinessEntityNotices'),
)
const BusinessEntityNoticesDetail = React.lazy(() =>
  import('./views/businessEntityNotices/BusinessEntityNoticesDetail'),
)
const Departments = React.lazy(() => import('./views/departments/Departments'))
const DepartmentsDetail = React.lazy(() => import('./views/departments/DepartmentsDetail'))
const DocumentTypes = React.lazy(() => import('./views/documentTypes/DocumentTypes'))
const DocumentTypesDetail = React.lazy(() => import('./views/documentTypes/DocumentTypesDetail'))
const EmailHistory = React.lazy(() => import('./views/emailHistory/EmailHistory'))
const EmailHistoryDetail = React.lazy(() => import('./views/emailHistory/EmailHistoryDetail'))
const ExternalDocuments = React.lazy(() => import('./views/externalDocuments/ExternalDocuments'))
const ExternalDocumentsDetail = React.lazy(() =>
  import('./views/externalDocuments/ExternalDocumentsDetail'),
)
const Positions = React.lazy(() => import('./views/positions/Positions'))
const PositionsDetail = React.lazy(() => import('./views/positions/PositionsDetail'))
/*const Regions = React.lazy(() => import('./views/regions/Regions'))
const RegionsDetail = React.lazy(() => import('./views/regions/RegionsDetail'))
const RegionsCreate = React.lazy(() => import('./views/regions/RegionsCreate'))*/
const Staffs = React.lazy(() => import('./views/staffs/Staffs'))
const StaffsDetail = React.lazy(() => import('./views/staffs/StaffsDetail'))
const Users = React.lazy(() => import('./views/users/Users'))
const UsersDetail = React.lazy(() => import('./views/users/UsersDetail'))
const UserRoles = React.lazy(() => import('./views/userRoles/UserRoles'))
const UserRolesDetail = React.lazy(() => import('./views/userRoles/UserRolesDetail'))
const ESigns = React.lazy(() => import('./views/eSigns/eSigns'))

const Colors = React.lazy(() => import('./views/theme/colors/Colors'))
const Typography = React.lazy(() => import('./views/theme/typography/Typography'))

// Base
const Accordion = React.lazy(() => import('./views/base/accordion/Accordion'))
const Breadcrumbs = React.lazy(() => import('./views/base/breadcrumbs/Breadcrumbs'))
const Cards = React.lazy(() => import('./views/base/cards/Cards'))
const Carousels = React.lazy(() => import('./views/base/carousels/Carousels'))
const Collapses = React.lazy(() => import('./views/base/collapses/Collapses'))
const ListGroups = React.lazy(() => import('./views/base/list-groups/ListGroups'))
const Navs = React.lazy(() => import('./views/base/navs/Navs'))
const Paginations = React.lazy(() => import('./views/base/paginations/Paginations'))
const Placeholders = React.lazy(() => import('./views/base/placeholders/Placeholders'))
const Popovers = React.lazy(() => import('./views/base/popovers/Popovers'))
const Progress = React.lazy(() => import('./views/base/progress/Progress'))
const Spinners = React.lazy(() => import('./views/base/spinners/Spinners'))
const Tables = React.lazy(() => import('./views/base/tables/Tables'))
const Tooltips = React.lazy(() => import('./views/base/tooltips/Tooltips'))

// Buttons
const Buttons = React.lazy(() => import('./views/buttons/buttons/Buttons'))
const ButtonGroups = React.lazy(() => import('./views/buttons/button-groups/ButtonGroups'))
const Dropdowns = React.lazy(() => import('./views/buttons/dropdowns/Dropdowns'))

//Forms
const ChecksRadios = React.lazy(() => import('./views/forms/checks-radios/ChecksRadios'))
const FloatingLabels = React.lazy(() => import('./views/forms/floating-labels/FloatingLabels'))
const FormControl = React.lazy(() => import('./views/forms/form-control/FormControl'))
const InputGroup = React.lazy(() => import('./views/forms/input-group/InputGroup'))
const Layout = React.lazy(() => import('./views/forms/layout/Layout'))
const Range = React.lazy(() => import('./views/forms/range/Range'))
const Select = React.lazy(() => import('./views/forms/select/Select'))
const Validation = React.lazy(() => import('./views/forms/validation/Validation'))

const Charts = React.lazy(() => import('./views/charts/Charts'))

// Icons
const CoreUIIcons = React.lazy(() => import('./views/icons/coreui-icons/CoreUIIcons'))
const Flags = React.lazy(() => import('./views/icons/flags/Flags'))
const Brands = React.lazy(() => import('./views/icons/brands/Brands'))

// Notifications
const Alerts = React.lazy(() => import('./views/notifications/alerts/Alerts'))
const Badges = React.lazy(() => import('./views/notifications/badges/Badges'))
const Modals = React.lazy(() => import('./views/notifications/modals/Modals'))
const Toasts = React.lazy(() => import('./views/notifications/toasts/Toasts'))

const Widgets = React.lazy(() => import('./views/widgets/Widgets'))

const Updates = React.lazy(() => import('./views/updates/Updates'))
const Tasks = React.lazy(() => import('./views/tasks/Tasks'))
const TaskCategories = React.lazy(() => import('./views/taskCategories/TaskCategories'))
const TaskCategoriesDetail = React.lazy(() => import('./views/taskCategories/TaskCategoriesDetail'))
const Me = React.lazy(() => import('./views/pages/me/Me'))
const Settings = React.lazy(() => import('./views/pages/settings/Settings'))
const TradingReport = React.lazy(() => import('./views/reports/TradingReport'))
const AccountReport = React.lazy(() => import('./views/reports/AccountReport'))
const JobRecord = React.lazy(() => import('./views/JobRecord/JobRecord'))
const InventoryReport = React.lazy(() => import('./views/reports/InventoryReport'))
const HRReport = React.lazy(() => import('./views/reports/HRReport'))
const ProjectReport = React.lazy(() => import('./views/reports/ProjectReport'))

let _routes = [
  { path: '/', exact: true, name: 'Home' },
  { path: '/dashboard', name: 'Dashboard', component: Dashboard },

  { path: '/theme', name: 'Theme', component: Colors, exact: true },
  { path: '/theme/colors', name: 'Colors', component: Colors },
  { path: '/theme/typography', name: 'Typography', component: Typography },
  { path: '/base', name: 'Base', component: Cards, exact: true },
  { path: '/base/accordion', name: 'Accordion', component: Accordion },
  { path: '/base/breadcrumbs', name: 'Breadcrumbs', component: Breadcrumbs },
  { path: '/base/cards', name: 'Cards', component: Cards },
  { path: '/base/carousels', name: 'Carousel', component: Carousels },
  { path: '/base/collapses', name: 'Collapse', component: Collapses },
  { path: '/base/list-groups', name: 'List Groups', component: ListGroups },
  { path: '/base/navs', name: 'Navs', component: Navs },
  { path: '/base/paginations', name: 'Paginations', component: Paginations },
  { path: '/base/placeholders', name: 'Placeholders', component: Placeholders },
  { path: '/base/popovers', name: 'Popovers', component: Popovers },
  { path: '/base/progress', name: 'Progress', component: Progress },
  { path: '/base/spinners', name: 'Spinners', component: Spinners },
  { path: '/base/tables', name: 'Tables', component: Tables },
  { path: '/base/tooltips', name: 'Tooltips', component: Tooltips },
  { path: '/buttons', name: 'Buttons', component: Buttons, exact: true },
  { path: '/buttons/buttons', name: 'Buttons', component: Buttons },
  { path: '/buttons/dropdowns', name: 'Dropdowns', component: Dropdowns },
  { path: '/buttons/button-groups', name: 'Button Groups', component: ButtonGroups },
  { path: '/charts', name: 'Charts', component: Charts },
  { path: '/forms', name: 'Forms', component: FormControl, exact: true },
  { path: '/forms/form-control', name: 'Form Control', component: FormControl },
  { path: '/forms/select', name: 'Select', component: Select },
  { path: '/forms/checks-radios', name: 'Checks & Radios', component: ChecksRadios },
  { path: '/forms/range', name: 'Range', component: Range },
  { path: '/forms/input-group', name: 'Input Group', component: InputGroup },
  { path: '/forms/floating-labels', name: 'Floating Labels', component: FloatingLabels },
  { path: '/forms/layout', name: 'Layout', component: Layout },
  { path: '/forms/validation', name: 'Validation', component: Validation },
  { path: '/icons', exact: true, name: 'Icons', component: CoreUIIcons },
  { path: '/icons/coreui-icons', name: 'CoreUI Icons', component: CoreUIIcons },
  { path: '/icons/flags', name: 'Flags', component: Flags },
  { path: '/icons/brands', name: 'Brands', component: Brands },
  { path: '/notifications', name: 'Notifications', component: Alerts, exact: true },
  { path: '/notifications/alerts', name: 'Alerts', component: Alerts },
  { path: '/notifications/badges', name: 'Badges', component: Badges },
  { path: '/notifications/modals', name: 'Modals', component: Modals },
  { path: '/notifications/toasts', name: 'Toasts', component: Toasts },
  { path: '/widgets', name: 'Widgets', component: Widgets },

  { path: '/updates', name: 'Updates', component: Updates },
  { path: '/tasks', name: 'Tasks', component: Tasks },
  { path: '/task-categories/:id', name: 'Task Categories Detail', component: TaskCategoriesDetail },
  { path: '/task-categories', name: 'Task Categories', component: TaskCategories },
  { path: '/me', name: 'Profile', component: Me },
  { path: '/settings', name: 'Settings', component: Settings },

  { path: '/trading-report', name: 'Trading Report', component: TradingReport },
  { path: '/account-report', name: 'Account Report', component: AccountReport },
  { path: '/inventory-management-report', name: 'Inventory Report', component: InventoryReport },
  { path: '/human-resource-management-report', name: 'HR Report', component: HRReport },
  { path: '/project-management-report', name: 'Project Report', component: ProjectReport },

  { path: '/job-record', name: 'Job Record', component: JobRecord },
]

const general_routes = []

if (_modules.business_entities) {
  general_routes.push(
    ...[
      {
        path: '/business-entities/:id',
        name: 'Business Entities Detail',
        component: BusinessEntitiesDetail,
      },
      { path: '/business-entities', name: 'Business Entities', component: BusinessEntities },
    ],
  )
  general_routes.push(
    ...[
      { path: '/departments/:id', name: 'Departments Detail', component: DepartmentsDetail },
      { path: '/departments', name: 'Departments', component: Departments },
    ],
  )
  general_routes.push(
    ...[
      { path: '/positions/:id', name: 'Positions Detail', component: PositionsDetail },
      { path: '/positions', name: 'Positions', component: Positions },
    ],
  )
}
if (_modules.business_entity_notices) {
  general_routes.push(
    ...[
      {
        path: '/business-entity-notices/:id',
        name: 'Business Entity Notices Detail',
        component: BusinessEntityNoticesDetail,
      },
      {
        path: '/business-entity-notices',
        name: 'Business Entity Notices',
        component: BusinessEntityNotices,
      },
    ],
  )
}
if (_modules.document_types)
  general_routes.push(
    ...[
      {
        path: '/document-types/:id',
        name: 'Document Types Detail',
        component: DocumentTypesDetail,
      },
      { path: '/document-types', name: 'Document Types', component: DocumentTypes },
    ],
  )
if (_modules.email_logs)
  general_routes.push(
    ...[
      {
        path: '/email-logs/:id',
        name: 'Email History',
        component: EmailHistoryDetail,
      },
      { path: '/email-logs', name: 'Email History', component: EmailHistory },
    ],
  )
if (_modules.external_documents)
  general_routes.push(
    ...[
      {
        path: '/external-documents/:id',
        name: 'External Documents Detail',
        component: ExternalDocumentsDetail,
      },
      { path: '/external-documents', name: 'External Documents', component: ExternalDocuments },
    ],
  )

/*if (_modules.regions)
  general_routes.push(
    ...[
      { path: '/regions/:id', name: 'Regions Detail', component: RegionsDetail },
      { path: '/regions', name: 'Regions', component: Regions },
    ],
  )*/
if (_modules.staffs)
  general_routes.push(
    ...[
      { path: '/staffs/:id', name: 'Staffs Detail', component: StaffsDetail },
      { path: '/staffs', name: 'Staffs', component: Staffs },
    ],
  )
if (_modules.users) {
  general_routes.push(
    ...[
      { path: '/users/:id', name: 'Users Detail', component: UsersDetail },
      { path: '/users', name: 'Users', component: Users },
    ],
  )
  general_routes.push(
    ...[
      {
        path: '/users-permissions/roles/:id',
        name: 'User Roles Detail',
        component: UserRolesDetail,
      },
      { path: '/users-permissions/roles', name: 'User Roles', component: UserRoles },
    ],
  )
}

if (_modules.e_signs) _routes.push(...[{ path: '/e-signs', name: 'E-Signs', component: ESigns }])

// import modules routes
_routes = _routes.concat(general_routes)
_routes = _routes.concat(trading_routes) // Trading module
_routes = _routes.concat(account_routes) // Account module
_routes = _routes.concat(inventory_management_routes) // Inventory Management module
_routes = _routes.concat(human_resource_management_routes) // Human Resource Management module
_routes = _routes.concat(project_management_routes) // Project Management module
_routes = _routes.concat(job_management_routes) // Job Management module
_routes = _routes.concat(meeting_management_routes) // Meeting Management module
_routes = _routes.concat(questionnaire_management_routes) // Questionnaire Management module

export default _routes
